module.exports = __webpack_public_path__ + "2cd33015c8dfb92a29b61062fbc3b14f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_18.jpg
// module id = 1665
// module chunks = 5